import React from 'react';
import './assets/css/custom.css';
import { AppRoutes } from './components/AppRoutes';

export const App: React.FC = () => {

    return (
        <AppRoutes />
    );
};
